import Cookies from 'js-cookie';

export const hasLogToConsoleCookie = (): boolean =>
  !!Cookies.get('log-to-console');
